import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const cat = categories.find((c) => c.slug === pathSegments[1]);
    breadcrumbs.push({ label: cat?.name || pathSegments[1], href: location.pathname });
  }

  if (pathSegments[0] === 'article' && pathSegments[1]) {
    breadcrumbs.push({ label: '文章详情' });
  }

  if (pathSegments[0] === 'about') {
    breadcrumbs.push({ label: '关于我们' });
  }

  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center gap-2 text-sm text-foreground-500">
        {breadcrumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>}
            {crumb.href && index < breadcrumbs.length - 1 ? (
              <Link to={crumb.href} className="hover:text-primary-500 transition-colors">
                {crumb.label}
              </Link>
            ) : (
              <span className={index === breadcrumbs.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}